import React from 'react';
import { CheckRegular } from 'emerald-icons/dist/CheckRegular';
import { accent0 } from '../globals/colors';
import styled from 'styled-components';
import { Token } from './Token.style';

export var CheckmarkToken = styled(Token).attrs(function () {return {
    children: /*#__PURE__*/React.createElement(CheckRegular, null)
  };}).withConfig({ displayName: "CheckmarkToken", componentId: "sc-vhsb22-0" })(["background:", ";"],
accent0);
//# sourceMappingURL=CheckmarkToken.js.map